
  <h1 mat-dialog-title style="text-align:center;">Plan Info for {{data.job.street_address}} ({{data.job.subdivision_name}}-{{data.job.lot}} )</h1>
  <div>
    <div>
      <p style="text-align: center;
    font-size: 20px;"> Square Footage: {{this.squarefootage > 0 ? this.squarefootage : 'Plan data not yet assigned'}}</p>
    </div>
    <div>
      <p style="text-align: center;
    font-size: 20px;"> Total Area: {{this.numberOfSystems > 0 ? this.numberOfSystems : 'Plan data not yet assigned'}} </p>
    </div>
  </div>


  <div style="position: relative;
    margin-top: 10px;
    top: 20px;
    /* left: 42px; */
    width: 70%;
    /* background: white;">
    <button mat-button (click)="dref.close()"  style="position: relative;
    left: 50%;
    background: #ffffff;
    border-radius: 5px;
    font-size: 24px;">Close</button>
  </div>

